import { render, staticRenderFns } from "./LeftDrawer.vue?vue&type=template&id=db5970bc&scoped=true"
import script from "./LeftDrawer.vue?vue&type=script&lang=js"
export * from "./LeftDrawer.vue?vue&type=script&lang=js"
import style0 from "./LeftDrawer.vue?vue&type=style&index=0&id=db5970bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5970bc",
  null
  
)

export default component.exports